module.exports = __webpack_public_path__ + "img/iot3.e0550472.png";